// This follows the same pattern as antd 'Validator' function signature
function validateIfDateIsBeforeAnother(form, dateToBeCompared, errorMessage) {
  return (rule, currentDate) => {
    const dateToBeComparedValue = form.getFieldValue(dateToBeCompared);

    if (currentDate?.isAfter(dateToBeComparedValue)) {
      return Promise.reject(errorMessage);
    }

    return Promise.resolve();
  };
}

function validateIfDateIsAfterAnother(form, dateToBeCompared, errorMessage) {
  return (rule, currentDate) => {
    const dateToBeComparedValue = form.getFieldValue(dateToBeCompared);

    if (currentDate?.isBefore(dateToBeComparedValue)) {
      return Promise.reject(errorMessage);
    }

    return Promise.resolve();
  };
}

export { validateIfDateIsAfterAnother, validateIfDateIsBeforeAnother };
